import { UnitV2 } from '@cemex-core/cmx-api';
import { AdtUnitsActions, AdtUnitsActionTypes } from '../../actions/units.actions';

/**
 * Admixture Products Store Interface
 */
export interface AdtUnitsState {
    loading: boolean;
    units: UnitV2[];
    unitsByProducts: { [productCode: string]: UnitV2[] };
    unitSelected?: UnitV2;
}

/**
 * Initial state of Admixture Units Store
 */
export const initialState: AdtUnitsState = {
    loading: false,
    units: undefined,
    unitsByProducts: undefined,
    unitSelected: undefined,
};

/**
 * @description Updates the state of Admixture units
 * @returns {AdtUnitsState}
 */
export function adtUnitsReducer(state = initialState, action: AdtUnitsActions): AdtUnitsState {
    switch (action.type) {
        case AdtUnitsActionTypes.LOAD_UNITS:
            const unitResponse = action.payload as UnitV2[];
            const newUnits: UnitV2[] = unitResponse
                .filter(unit => !state.units.some(unitState => unitState.unitId === unit.unitId));
            if (newUnits.length) {
                return {
                    ...state,
                    units: [...state.units, ...newUnits],
                } as AdtUnitsState;
            }
            return state;
        case AdtUnitsActionTypes.FETCH_UNITS_BY_PRODUCT:
            return {
                ...state,
                loading: true,
            } as AdtUnitsState;
        case AdtUnitsActionTypes.LOAD_UNITS_BY_PRODUCT:
            const unitsProduct = action.payload.units;
            let newUnitsProduct: UnitV2[];
            if (state.units) {
                const tmpUnits = unitsProduct
                    .filter(unit => !state.units.some(unitState => unitState.unitId === unit.unitId));
                newUnitsProduct = [...state.units, ...tmpUnits];
            } else {
                newUnitsProduct = [...action.payload.units];
            }
            const unitByProduct = { [action.payload.productCode]: unitsProduct };
            return {
                ...state,
                unitsByProducts: { ...state.unitsByProducts, ...unitByProduct },
                units: newUnitsProduct,
                loading: false,
            };
        case AdtUnitsActionTypes.RESET: {
            return {
                ...initialState,
            };
        }
        default: {
            return state;
        }
    }
}
